import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// import {
//     FacebookIcon,
//     FacebookShareButton,
// } from "react-share";

import "@fancyapps/ui/dist/fancybox.esm.js";
import "@fancyapps/ui/dist/fancybox.css";

//import ReactHtmlParser from 'react-html-parser';
import { Helmet } from 'react-helmet';

import * as Hosts from '../../../Hosts';
import { /*reqGET,*/ content_language, repo_img_link } from '../../../Utils';

import Loader from '../../../loader';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import Preview from '../Preview/Preview';
import Breadcrumb from '../Breadcrumb/Breadcrumb';

import AssecImage from "../ASSEC_Image/Image"

import { language } from '../WEBContent/Language';

export default function Study(props) {
    const { pathname } = useLocation();

    const [isloading, setLoading] = useState(true);

	const [lang, set_lang] = useState(localStorage.getItem('lang'));
	const [lang_id, set_lang_id] = useState('1');

    //const [/*link*/, set_link] = useState('')

    const data_interface = {
        id: '',
        info: {},
        content: {}
    }
    const [content, set_content] = useState(data_interface);
    const [dados_config, set_dados_config] = useState({});
    const [navbar, set_navbar] = useState({});

    useEffect(() => {

        try {

            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if (el.code === localStorage.getItem('lang')) {
                set_lang_id(el.id)
                }
            })

            if(props.info !== undefined && props.info !== null && props.info !== '') {
                set_dados_config(props.info.state.dados_config)
                set_navbar(props.info.state.dados_navbar)
                set_content(props.info.state.dados_content)
                
            }

            setLoading(false)

            return

        } catch {
            console.log('nada')

			return
		}
        
    }, [props.info]);

    const get_seo_data = (type) => {

        if(type === 'title') {
            if(content.info.seo !== undefined && content.info.seo['title'] !== undefined  && content.info.seo['title'] !== '') {
                return content.info.seo['title']
            } 
            else {
                return Hosts.SITES.SIMWEBSITE.DEFAULT_SEO_TITLE
            }
        }
        else if(type === 'description') {
            if(content.info.seo !== undefined && content.info.seo['description'] !== undefined  && content.info.seo['description'] !== '') {
                return content.info.seo['description']
            } 
            else if(content.content !== undefined && content.content.length > 0 && content.content[0]['abstract'] !== undefined && content.content[0]['abstract'] !== undefined  && content.content[0]['abstract'] !== '') {
                return content.content[0]['abstract']
            } 
            else {
                return Hosts.SITES.SIMWEBSITE.DEFAULT_SEO_DESCRIPTION
            }
        }
        if(type === 'keywords') {
            if(content.info.seo !== undefined && content.info.seo['keywords'] !== undefined  && content.info.seo['keywords'] !== '') {
                return content.info.seo['keywords']
            } 
            else {
                return Hosts.SITES.SIMWEBSITE.DEFAULT_SEO_KEYWORDS
            }
        }
        else if(type === 'image') {
            if(content.content !== undefined && content.content.length > 0 && content.content[0]['media'] !== undefined && content.content[0]['media']['image'] !== undefined && content.content[0]['media']['image'].length > 0 && content.content[0]['media']['image'][0]['link'] !== '') {
                return content.content[0]['media']['image'][0]['link']
            } 
            else {
                return Hosts.SITES.SIMWEBSITE.DEFAULT_SEO_IMAGE
            }
        }
        else if(type === 'link') {
            let title_seo = Hosts.WEB_SITE_URI + pathname
            return '.' + title_seo.replace("//", "/");
        }
    }

    return (isloading ?
		    <Loader />
		:
            <>
                {
                    content.info['preview'] === true ? 
                        <Preview />
                    : 
                        null
                }
                <Navbar dados_config={dados_config} dados_navbar={navbar} />
                <Breadcrumb dados_config={dados_config} dados_navbar={navbar} dados_content={content} />
                <main className="study-detail my-5">
                    <div>
                        <Helmet>
                            <title>{ get_seo_data('title') }</title>
                            <link rel="canonical" href={ get_seo_data('link') } />
                            <meta name="description" content={ get_seo_data('description') } />
                            <meta name="keywords" content={ get_seo_data('keywords') } />
                            <meta property="og:url" content={ get_seo_data('link') } />
                            <meta property="og:title" content={ get_seo_data('title') }></meta>
                            <meta property="og:description" content={ get_seo_data('description') }></meta>
                            <meta property="og:image" content={ get_seo_data('image') }></meta>
                            <meta name="twitter:title" content={ get_seo_data('title') }></meta>
                            <meta name="twitter:description" content={ get_seo_data('description') }></meta>
                            <meta name="twitter:image" content={ get_seo_data('image') }></meta>
                        </Helmet>
                    </div>
                    <div id="study-detail" className="container">
                        <div className="row">
                            <div className="col-12 text-end mb-3">
                                <a className="btn btn-link" href={'./study/all'} >
                                    <i className="bi bi-arrow-left"></i> {language[lang].back}
                                </a>
                            </div>
                        </div>
                        {
                            content.content.map((el, k) => {  
                                return (
                                    <div key={k} className="row">
                                        <div className='col-12 col-xl-9 mx-auto'>
                                            <div className='row gy-4 align-items-center'>
                                                <div className="div-content col-12 col-md-6 order-last order-md-first">
                                                    <h1 className={el.title !== '' ? "study-title mb-3" : "d-none"}>
                                                        {lang === 'pt' || el.language === undefined ? el.title : (el.language[lang_id] === undefined || el.language[lang_id] === null || el.language[lang_id].title === undefined || el.language[lang_id].title === '' ? el.title : el.language[lang_id].title)}
                                                    </h1>

                                                    {
                                                        el.cultivation_type !== undefined && el.cultivation_type !== '' ?
                                                            <div className="study-cultivation_type mb-3">
                                                                <div className="study-label">
                                                                    {language[lang].study_cultivation_type}
                                                                </div>
                                                                <div className='cultivation_type-value'>
                                                                    {el.cultivation_type}
                                                                </div>
                                                            </div>
                                                        :
                                                            null
                                                    }

                                                    {
                                                        el.area !== undefined && el.area !== '' ?
                                                            <div className="study-area mb-3">
                                                                <div className="study-label">
                                                                    {language[lang].study_area}
                                                                </div>
                                                                <div className='municipality-value'>
                                                                    {el.area}&nbsp;(Ha)
                                                                </div>
                                                            </div>
                                                        :
                                                            null
                                                    }

                                                    {
                                                        el.municipality !== undefined && el.municipality !== '' ?
                                                            <div className="study-municipality mb-3">
                                                                <div className="study-label">
                                                                    {language[lang].study_municipality}
                                                                </div>
                                                                <div className='municipality-value'>
                                                                    {el.municipality}
                                                                </div>
                                                            </div>
                                                        :
                                                            null
                                                    }

                                                    {
                                                        el.tecnology !== undefined && el.tecnology !== '' ?
                                                            <div className="study-tecnology mb-3">
                                                                <div className="study-label">
                                                                    {language[lang].study_technological_solution}
                                                                </div>
                                                                <div className='tecnology-value'>
                                                                    {language[lang]['study_' + el.tecnology]}
                                                                </div>
                                                            </div>
                                                        :
                                                            null
                                                    }

                                                    {
                                                        el.cost !== undefined && el.cost !== '' && 0 ?
                                                            <div className="study-cost mb-3">
                                                                <div className="study-label">
                                                                    {language[lang].study_cost}
                                                                </div>
                                                                <div className='cost-value'>
                                                                    {el.cost}&nbsp;&euro;
                                                                </div>
                                                            </div>
                                                        :
                                                            null
                                                    }

                                                    {
                                                        el.payback !== undefined && el.payback !== '' && 0 ?
                                                            <div className="study-payback mb-3">
                                                                <div className="study-label">
                                                                    {language[lang].study_payback}
                                                                </div>
                                                                <div className='payback-value'>
                                                                    {el.payback}
                                                                </div>
                                                            </div>
                                                        :
                                                            null
                                                    }
                                                    
                                                    {
                                                        el.energy_savings !== undefined && el.energy_savings !== '' ?
                                                            <div className="study-energy-saving">
                                                                <div className="energy-saving-label">
                                                                    {language[lang].study_energy_savings}
                                                                </div>
                                                                <div className='energy-saving-value'>
                                                                    {el.energy_savings}
                                                                    {
                                                                        el.tecnology === 'technological_solution_3' ?
                                                                            <span className='small'>&nbsp;kWh</span>
                                                                        :
                                                                            <span>%</span>   
                                                                    }
                                                                </div>
                                                            </div>
                                                        :
                                                            null
                                                    }

                                                    {/*<div className={"div-text mb-3"}>
                                                        <div style={{display: 'inline-flex', flexWrap: 'nowrap', flexDirection: 'column'}}>
                                                            {
                                                                el.contacts['morada'] !== undefined && el.contacts.morada !== '' ?
                                                                    <span style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start'}} className="mb-2">
                                                                        <i className="bi bi-house me-2"></i>
                                                                        {ReactHtmlParser(el.contacts.morada.replaceAll('\n', '<br/>'))}
                                                                    </span>
                                                                :
                                                                    null
                                                            } 
                                                            {
                                                                el.contacts['website'] !== undefined && el.contacts.website !== '' ?
                                                                    <span style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', lineHeight: '2'}}>
                                                                        <i className="bi bi-globe me-2"></i> 
                                                                        <a href={el.contacts.website.includes('http') ? el.contacts.website : 'http://' + el.contacts.website} target="_blank" rel="noreferrer">
                                                                            {
                                                                            link !== undefined ? link : null
                                                                            //el.contacts.website.includes(el.contacts.website_type) ? el.contacts.website : el.contacts.website_type + el.contacts.website
                                                                            }
                                                                        </a>
                                                                    </span>
                                                                    :
                                                                    null
                                                            }
                                                            {
                                                                el.contacts.email !== '' ?
                                                                    <span style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', lineHeight: '2'}}>
                                                                        <i className="bi bi-envelope me-2"></i>
                                                                        <a href={'mailto: '+ el.contacts.email} target="_blank" rel="noreferrer">
                                                                            {el.contacts.email}
                                                                        </a>
                                                                    </span>
                                                                :
                                                                    null
                                                            } 
                                                            {
                                                                content.info.category !== '' ?
                                                                    <span style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', lineHeight: '2'}} className='d-none'>
                                                                        <strong>{content.info.category}</strong>
                                                                    </span>
                                                                :
                                                                    null
                                                            }
                                                            {
                                                                el.contacts.tlf !== '' ?
                                                                    <span style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', lineHeight: '2'}}>
                                                                        <i className="bi bi-telephone me-2"></i>
                                                                        <a href={"tel:" + el.contacts.tlf}>{el.contacts.tlf}</a>
                                                                    </span>
                                                                :
                                                                    null
                                                            }
                                                            {
                                                                el.contacts.tlm !== '' ?
                                                                    <span style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', lineHeight: '2'}}>
                                                                        <i className="bi bi-phone me-2"></i>
                                                                        <a href={"tel: " + el.contacts.tlm}>{el.contacts.tlm}</a> <br /></span>
                                                                :
                                                                    null
                                                            }
                                                        </div>
                                                    </div>
                                                    {
                                                        el.abstract !== '' ?
                                                            <div className={"study-abstract mb-3"}>
                                                                {ReactHtmlParser(lang === 'pt' || el.language === undefined ? el.abstract : (el.language[lang_id] === undefined || el.language[lang_id] === null || el.language[lang_id].abstract === undefined || el.language[lang_id].abstract === '' ? el.abstract : el.language[lang_id].abstract))}
                                                            </div>
                                                        : null 
                                                    }
                                                    {
                                                        el.text !== '' && el.text !== '<p></p>\n' ?

                                                            <div className="study-text">
                                                                {ReactHtmlParser(lang === 'pt' || el.language === undefined ? el.text : (el.language[lang_id] === undefined || el.language[lang_id] === null || el.language[lang_id].text === undefined || el.language[lang_id].text === '' || el.language[lang_id].text === '<p></p>\n' ? el.text : el.language[lang_id].text))}
                                                            </div>
                                                        : null 
                                                    }*/}
                                                </div>
                                                {
                                                    lang !== 'pt' && el['language'] !== undefined && el['language'][lang_id] !== undefined && el['language'][lang_id] !== null && el['language'][lang_id]['media'] !== null && el['language'][lang_id]['media']['image'] !== undefined && el.language[lang_id]['media']['image'].length > 0 ?
                                                        <div className={"div-image col-12 col-md-6 order-first order-md-last"}>
                                                            <div className="study-image">
                                                                {
                                                                    el['language'][lang_id]['media'][0]['url'] !== undefined && el['language'][lang_id]['media'][0]['url'] !== '' ?
                                                                        <a href={el['language'][lang_id]['media'][0]['url'].includes('http') ? el['language'][lang_id]['media'][0]['url'] : 'https://' + el['language'][lang_id]['media'][0]['url'] } target="_blank" rel="noreferrer" title={el['language'][lang_id]['media'][0]['name'].includes('webp') || el['language'][lang_id]['media'][0]['name'].includes('jpg') || el['language'][lang_id]['media'][0]['name'].includes('png') ? '' : el['language'][lang_id]['media'][0]['name']}>
                                                                            <AssecImage 
                                                                                linkImage={el['language'][lang_id]['media']['image'][0]['link']}
                                                                                width="500"
                                                                                height="500"
                                                                                fit='crop'
                                                                                type='img'
                                                                                sClass="img-fluid" 
                                                                                alt={el['language'][lang_id]['media']['image'][0]['name']}
                                                                            />
                                                                        </a>

                                                                    :
                                                                        <a
                                                                            href={el['language'][lang_id]['media']['image'][0]['link']}
                                                                            data-fancybox="study-gallery"
                                                                            data-caption={el['language'][lang_id]['media']['image'][0]['name'].includes('webp') || el['language'][lang_id]['media']['image'][0]['name'].includes('jpg') || el['language'][lang_id]['media']['image'][0]['name'].includes('png') ? '' : el['language'][lang_id]['media']['image'][0]['name']}
                                                                        >
                                                                            <AssecImage 
                                                                                linkImage={el['language'][lang_id]['media']['image'][0]['link']}
                                                                                width="500"
                                                                                height="500"
                                                                                fit='crop'
                                                                                type='img'
                                                                                sClass="img-fluid" 
                                                                                alt={el['language'][lang_id]['media']['image'][0]['name']}
                                                                            />
                                                                        </a>
                                                                }
                                                            </div>
                                                        </div>
                                                    :
                                                        el['media'] !== undefined && el['media']['image'] !== undefined && el['media']['image'].length > 0 ?
                                                            <div className={"div-image col-12 col-md-6 order-first order-md-last"}>
                                                                <div className="study-image">
                                                                    {
                                                                        el['media']['image'][0]['url'] !== undefined && el['media']['image'][0]['url'] !== '' ?

                                                                            <a href={el['media']['image'][0]['url'].includes('http') ? el['media']['image'][0]['url'] : 'https://' + el['media']['image'][0]['url'] } target="_blank" rel="noreferrer" title={el['media']['image'][0]['name'].includes('webp') || el['media']['image'][0]['name'].includes('jpg') || el['media']['image'][0]['name'].includes('png') ? '' : el['media']['image'][0]['name']}>
                                                                                <AssecImage 
                                                                                    linkImage={el['media']['image'][0]['link'] !== '' ? el['media']['image'][0]['link'] : repo_img_link('nophoto.webp')}
                                                                                    width="500"
                                                                                    height="500"
                                                                                    fit='crop'
                                                                                    type='img'
                                                                                    sClass="img-fluid" 
                                                                                    alt={el['media']['image'][0]['name']}
                                                                                />
                                                                            </a>
                                                                        :
                                                                            <a
                                                                                href={el['media']['image'][0]['link']}
                                                                                data-fancybox="study-gallery"
                                                                                data-caption={el['media']['image'][0]['name'].includes('webp') || el['media']['image'][0]['name'].includes('jpg') || el['media']['image'][0]['name'].includes('png') ? '' : el['media']['image'][0]['name']}
                                                                            >
                                                                                <AssecImage 
                                                                                    linkImage={el['media']['image'][0]['link'] !== '' ? el['media']['image'][0]['link'] : repo_img_link('nophoto.webp')}
                                                                                    width="500"
                                                                                    height="500"
                                                                                    fit='crop'
                                                                                    type='img'
                                                                                    sClass="img-fluid" 
                                                                                    alt={el['media']['image'][0]['name']}
                                                                                />
                                                                            </a>
                                                                    }
                                                                </div>
                                                            </div>
                                                        :
                                                            <div className={"div-image col-12 col-md-6 order-first order-md-last"}>
                                                                <div className="study-image">
                                                                    <a
                                                                        href={repo_img_link('nophoto.webp')}
                                                                        data-fancybox="study-gallery"
                                                                        data-caption={''}
                                                                    >
                                                                        <AssecImage 
                                                                            linkImage={repo_img_link('nophoto.webp')}
                                                                            width="500"
                                                                            height="500"
                                                                            fit='crop'
                                                                            type='img'
                                                                            sClass="img-fluid" 
                                                                            alt="no_photo"
                                                                        />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                }
                                            </div>
                                        </div>
                                        {
                                            el['media'] !== undefined && el['media']['image'] !== undefined && el.media.image.length > 1 ?
                                                <div className="col-12 study-gallery mt-3">
                                                    <div className="row">
                                                        {
                                                        el.media.image.map((el_img, k_img) => {
                                                            if(k_img > 0) {

                                                                return (
                                                                    <div key={k_img} className="col-6 col-md-3 col-lg-2 mb-4">
                                                                        {
                                                                            el_img.url !== undefined && el_img.url !== '' ?
                                                                                <a 
                                                                                    href={el_img.url.includes('http') ? el_img.url : 'https://' + el_img.url }
                                                                                    target="_blank" 
                                                                                    rel="noreferrer" 
                                                                                    title={el_img.name.includes('webp') || el_img.name.includes('jpg') || el_img.name.includes('png') ? '' : el_img.name}>
                                                                                    <figure className="figure m-0">
                                                                                        <AssecImage 
                                                                                            linkImage={el_img.link}
                                                                                            width="400"
                                                                                            height="300"
                                                                                            fit='crop'
                                                                                            type='img'
                                                                                            sClass="img-fluid shadow-sm" 
                                                                                            alt={el_img.name}
                                                                                        />
                                                                                        {
                                                                                            (el_img.name.includes('webp') || el_img.name.includes('jpg') || el_img.name.includes('png')) ?
                                                                                                ''
                                                                                            :
                                                                                                <figcaption className='figure-caption p-3 text-center' >{el_img.name}</figcaption>
                                                                                        }
                                                                                    </figure>
                                                                                </a>
                                                                            :

                                                                                <a
                                                                                    href={el_img.link}
                                                                                    data-fancybox="study-gallery"
                                                                                    data-caption={(el_img.name.includes('webp') || el_img.name.includes('jpg') || el_img.name.includes('png')) ? '' : el_img.name}
                                                                                >
                                                                                    <figure className="figure m-0">
                                                                                        <AssecImage 
                                                                                            linkImage={el_img.link}
                                                                                            width="400"
                                                                                            height="300"
                                                                                            fit='crop'
                                                                                            type='img'
                                                                                            sClass="img-fluid shadow-sm" 
                                                                                            alt={el_img.name}
                                                                                        />
                                                                                        {
                                                                                            (el_img.name.includes('webp') || el_img.name.includes('jpg') || el_img.name.includes('png')) ?
                                                                                                ''
                                                                                            :
                                                                                                <figcaption className='figure-caption p-3 text-center' >{el_img.name}</figcaption>
                                                                                        }
                                                                                    </figure>
                                                                                </a>
                                                                        }
                                                                        
                                                                    </div>
                                                                )
                                                            }
                                                            else
                                                                return null
                                                        })
                                                        }
                                                    </div>
                                                </div>
                                            :
                                                null
                                        }
                                        {
                                            lang !== 'pt' && el['language'] !== undefined && el['language'][lang_id] !== undefined && el['language'][lang_id] !== null && el['language'][lang_id]['media'] !== null && el['language'][lang_id]['media']['doc'] !== undefined && el.language[lang_id]['media']['doc'].length > 0 ?
                                                <div className="col-12 study-documents mt-3">
                                                    {
                                                        el.language[lang_id]['media']['doc'].map((el_doc, k_doc) => {
                                                            return (
                                                                <a key={k_doc} className="btn btn-primary mb-2 me-2" href={el_doc.link} rel="noreferrer" target="_blank">
                                                                    {el_doc.name} <i className="bi bi-filetype-pdf ps-2 fs-6"></i>
                                                                </a>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            :
                                                el['media'] !== undefined && el['media']['doc'] !== undefined && el.media.doc.length > 0 ?
                                                    <div className="col-12 study-documents mt-3">
                                                        {
                                                        el.media.doc.map((el_doc, k_doc) => {
                                                            return (
                                                                <a key={k_doc} className="btn btn-primary mb-2 me-2" href={el_doc.link} target="_blank" rel="noreferrer">
                                                                    {el_doc.name} <i className="bi bi-filetype-pdf ps-2 fs-6"></i>
                                                                </a>
                                                            )
                                                        })
                                                        }
                                                    </div>
                                                :
                                                    null
                                        }
                                    </div>
                                )
                            })
                        }
                    </div> 
                </main>
                <Footer dados_config={dados_config} dados_navbar={navbar} />
            </>
    )
}